/* eslint-disable no-empty-pattern */
/* eslint-disable @typescript-eslint/no-empty-function */

import React from 'react';
import { CurrencyCode } from '@99designs/i18n';
import * as BudgetField from './BudgetField';
import * as ClientConfiguredField from './ClientConfiguredField';
import * as ContestUpgradesChoiceField from './ContestUpgradesChoiceField';
import * as DateField from './DateField';
import { FieldFragment } from './Field.generated';
import * as FilesField from './FilesField';
import * as GridChoiceField from './GridChoiceField';
import * as InputField from './InputField';
import * as LogoContestTierChoiceField from './LogoContestTierChoiceField';
import * as MultiChoiceField from './MultiChoiceField';
import * as MultiGridChoiceField from './MultiGridChoiceField';
import * as MultiInputField from './MultiInputField';
import * as MultiSelectChoiceField from './MultiSelectChoiceField';
import * as PrintServiceOptionsField from './PrintServiceOptionsField';
import * as RadioChoiceField from './RadioChoiceField';
import * as SelectChoiceField from './SelectChoiceField';
import * as SquarespacePackageChoiceField from './SquarespacePackageChoiceField';
import * as TextAreaField from './TextAreaField';
import * as WorkEntityField from './WorkEntityField';

type CategoryFieldsFragment = {
    key: string;
    title: string;
    priceRange: Array<number>;
};

type ViewProps = FieldFragment & {
    briefId?: string;
    currency?: CurrencyCode;
    category?: CategoryFieldsFragment | null;
};

type EditProps = FieldFragment & {
    // TODO: Fetch from context in field
    uploader?: FilesField.UploaderConfig;
    category?: CategoryFieldsFragment | null;
    currency?: CurrencyCode;
    fulfilmentMpvId?: string;
};

interface Field {
    Edit: React.FunctionComponent<EditProps>;
    View: React.FunctionComponent<ViewProps>;
    HasValue: (props: ViewProps) => boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getValue: (props: ViewProps) => any;
}

const fields: Record<FieldFragment['__typename'], Field> = {
    SelectChoiceField,
    MultiSelectChoiceField,
    GridChoiceField,
    RadioChoiceField,
    BudgetField,
    DateField,
    TextAreaField,
    MultiChoiceField,
    FilesField,
    SquarespacePackageChoiceField,
    LogoContestTierChoiceField,
    ContestUpgradesChoiceField,
    PrintServiceOptionsField,
    InputField,
    MultiInputField,
    MultiGridChoiceField,
    ClientConfiguredField,
    WorkEntityField,
};

/**
 * Readonly brief field component rendered based on GrahphQL `__typename`
 */
export function View(props: ViewProps) {
    const field = fields[props.__typename];
    return <field.View {...props} />;
}

/**
 * Editable brief field component rendered based on GrahphQL `__typename`
 */
export function Edit(props: EditProps) {
    const field = fields[props.__typename];
    return <field.Edit {...props} />;
}

export function hasValue(props: ViewProps): boolean {
    const field = fields[props.__typename];
    return field.HasValue(props);
}

export function getValue(props: ViewProps) {
    const field = fields[props.__typename];
    return field.getValue(props);
}
